<form [formGroup]="inputFormArray" *ngIf="inputFormArray">
  <ng-content></ng-content>

  <div
    class="form-element"
    *ngFor="let doc of inputFormArray.controls; let docIndex = index; first as isFirst; last as isLast"
    [formGroupName]="docIndex">
    <div *ngIf="showItem(docIndex)" class="document-wrapper" fxLayoutAlign="space-between center">
      <span fxLayoutAlign=" center">
        <mat-icon class="file-icon">description</mat-icon>
        <a
          href="{{ doc.get('url').value }}"
          target="_blank"
          matTooltip="In neuem Tab öffnen"
          matTooltipPosition="above">
          {{ doc.get('displayName').value }}
          <span *ngIf="showTag">{{ doc.get('tag').value }}</span>
        </a>
      </span>
      <span>
        <button
          *ngIf="editUpload"
          mat-icon-button
          (click)="delete(docIndex)"
          matTooltip="Datei löschen"
          matTooltipPosition="above"
          aria-label="Datei löschen">
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </div>
    <div
      style="margin-top: 1rem"
      *ngIf="
        (editUpload || showUploadButton) &&
        isLast &&
        numberShownElements > 0 &&
        numberShownElements < numberOfUploads
      ">
      <app-file-upload
        [tag]="documentTag"
        (savedDoc)="savedDoc($event, null)"
        (onClick)="inputFormArray.markAsTouched()"
        [validFormats]="validFormats"></app-file-upload>
    </div>
  </div>
  <div *ngIf="(editUpload || showUploadButton) && numberShownElements == 0">
    <app-file-upload
      [disabledUploadButton]="!canUpdate"
      [tag]="documentTag"
      (onClick)="inputFormArray.markAsTouched()"
      (savedDoc)="savedDoc($event, null)"
      [validFormats]="validFormats"></app-file-upload>
  </div>
</form>
